import React from 'react'
import Logo from "../assets/logo.svg"
const NoScreen = () => {
    return (

        <section class="text-gray-600 body-font h-screen flex flex-col justify-center">
        <div class="container mx-auto flex px-5 py-24 items-center justify-center flex-col">
        <img src={Logo} alt="Viewpro" className="h-12" />
            <div class="text-center lg:w-2/3 w-full mt-16">
            <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">Error</h1>
            <p class="mb-8 text-xl leading-loose w-3/4 px-2 mx-auto">This page is not available on mobile phone please visit using desktop/laptop or iPad</p>
            <div class="flex justify-center">
                <a href="https://www.viewprogis.com/contact-viewprogis" class="inline-flex font-semibold text-white bg-primary border-0 py-4 px-12 focus:outline-none hover:bg-green-600 rounded-full text-xl">Contact Us</a>
            </div>
            </div>
        </div>
        </section>
           
    )
}

export default NoScreen
